module.exports = __webpack_public_path__ + "static/img/soft01.735d8090.png";